import { defineMessages } from "react-intl";

export const messages = defineMessages({
  empty: {
    id: "IhK1F3",
    defaultMessage: "No shipping zones found",
  },
  createShippingZone: {
    id: "mIUNgR",
    defaultMessage: "Create shipping zone",
    description: "button",
  },
  colName: {
    id: "gRa/TS",
    defaultMessage: "Name",
    description: "shipping zone",
  },
  colPriceRange: {
    id: "CFG1Ix",
    defaultMessage: "Price range",
    description: "shipping zone",
  },
  colCountries: {
    id: "aMwxYb",
    defaultMessage: "Countries",
  },
});
